import { TextRendererComponent } from 'src/app/shared/common-components/ag-grid/text-renderer/text-renderer.component';
import { StorageName } from './../../../../shared/enum/common-enum';
import { AgGridI, AgColDefsI} from 'src/app/shared/common-components/ag-grid/ag-grid.model';
import { EditDeleteIconComponent } from 'src/app/shared/common-components/ag-grid/edit-delete-icon/edit-delete-icon.component';
import { CheckboxRendererComponent } from 'src/app/shared/common-components/ag-grid/checkbox-renderer/checkbox-renderer.component';
import { API_URL_GET_ALL_CREATE_SHECME } from 'src/app/shared/url-helper/url-helper';
import { NumericCellRendererComponent } from 'src/app/shared/common-components/ag-grid/numeric-cell-renderer/numeric-cell-renderer.component';
import { StorageService } from 'src/app/shared/services/storage.service';
const SchemeName: AgColDefsI = {
  headerName: "Scheme Name", 
  field: 'schemeName', 
  headerClass:"px-0 custom-column-group-cell f-14 text-gray-color font-semibold  ag_header_fontSize",
  cellClass:'px-2 f-12 font-regular custom-column-group-cell text-primary',
  flex:1,
  sortable: true,
  editable:false,
  resizable: true,
  minWidth: 80,
  cellRendererParams :{isCursor:true},
  cellRenderer: TextRendererComponent,
};
const Redemptionon: AgColDefsI = {
  headerName: "Redemption on", 
  field: 'redemptionOnName', 
  headerClass:"px-0 custom-column-group-cell f-14 text-gray-color font-semibold  ag_header_fontSize",
  cellClass:'px-2 f-12 text-gray-color font-regular custom-column-group-cell',
  flex:1,
  sortable: true,
  editable:false,
  resizable: true,
  minWidth: 80,
  cellRenderer: TextRendererComponent,
};
const Duration: AgColDefsI = {
  headerName: "Duration", 
  field: 'durationInFormat', 
  headerClass:"px-0 custom-column-group-cell f-14 text-gray-color font-semibold  ag_header_fontSize",
  cellClass:'px-2 f-12 text-gray-color font-regular custom-column-group-cell ',
  flex:1,
  sortable: true,
  editable:false,
  resizable: true,
  minWidth: 70,
   cellRenderer:TextRendererComponent, 
 };
const InstallmentType: AgColDefsI = {
  headerName: "Installment Type", 
  field: 'installmentTypeName', 
  headerClass:"px-0 custom-column-group-cell f-14 text-gray-color font-semibold  ag_header_fontSize",
  cellClass:'px-2 f-12 text-gray-color font-regular custom-column-group-cell',
  flex:1,
  sortable: true,
  editable:false,
  resizable: true,
  minWidth: 70,
  cellRenderer:TextRendererComponent, 
 };

const InstallmentAmt: AgColDefsI = {
  headerName: "Installment Amt.",
  headerClass:"px-0 custom-column-group-cell f-14 text-gray-color font-semibold ag_header_end ag_header_fontSize",
  field: "installmentAmount",
  sortable: true,
  cellClass: "custom-column-group-cell text-gray-color font-regular text-end f-12",
  flex:1,
  editable: false,
  resizable: true,
  minWidth: 70,
  cellRenderer: NumericCellRendererComponent,
  cellRendererParams: { isAmt : true , isCursor:false},
};
const Active: AgColDefsI = {
  headerName: "Active",
  headerCheckboxSelection: false, 
  headerClass:"px-0 custom-column-group-cell f-14 text-gray-color font-semibold justify-content-center ag_header_fontSize",
  field: 'active',  
  sortable:true, 
  cellRenderer: CheckboxRendererComponent,
  cellRendererParams: { showLabel: false,isReadOnly:true }, 
  cellClass:'px-2 custom-column-group-cell d-flex justify-content-center',
  resizable: true,  
  editable:false,
  minWidth: 40,
  maxWidth: 80,
  flex:1,
};
const taskdelete: AgColDefsI = {
  headerName: "",
  headerClass:"px-0 customHeaderClass",
  field: "message2",
  cellRenderer: EditDeleteIconComponent,
  // cellRendererParams: { isDeleteIcon:true},
  cellRendererParams: (params: any) => {
    const storageService = new StorageService();
    const userPermissions = storageService.retrieve(StorageName.USER_PERMISSIONS);
    return {
      hasDeletePermission: userPermissions?.investmentFundCanDelete,
      isDeleteIcon:true
    };
  },
  cellClass: "custom-column-group-cell text-gray-color font-regular f-12 d-flex align-items-center justify-content-center",
  minWidth: 70,
  maxWidth: 70,
  editable: false,
  lockPosition:"right",
  lockPinned:true,
};
export const ColDefsTaskLog: AgColDefsI[] = [
  SchemeName,
  Redemptionon,
  Duration,
  InstallmentType,
  InstallmentAmt,
  Active,
  taskdelete,
  
];
export const AgGridDataModelCreateScheme: AgGridI = {
  colDefs: ColDefsTaskLog,
  rowSelection: "multiple",
  columnSettings:true,
  paginationStorageName : StorageName.PAGINATION_INVESTMENT_FUND_CREATE_SHECEM_GRID,
  storageName : StorageName.INVESTMENT_FUND_CREATE_SHECEM_GRID,
  filterStorageName: StorageName.FILTER_INVESTMENT_FUND_CREATE_SHECEM_GRID,
  sortStorageName: StorageName.SORT_INVESTMENT_FUND_CREATE_SHECEM_GRID,
  singleClickEdit:true,
  rows:[],
  headerHeight : 30,
  rowHeight:28,
  isFilter: true,  
  isServerSidepagination: true,  
  apiUrl : API_URL_GET_ALL_CREATE_SHECME,
  showPagination: false
};






